import axios from '../../functions/axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import style from './CarriagePaletteList2Print.module.css';
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from '../../hooks/useAuthContext';

const parseDate = (date = new Date()) => {
  return {
    week: moment(date).utc().startOf('isoWeek').isoWeek(),
    monthStart: new Date(moment(date).utc().startOf('month').toDate()),
    monthEnd: new Date(moment(date).utc().endOf('month').toDate()),
  };
};

export default function WeekView() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const initDate = parseDate(Date.parse(sessionStorage.getItem('selectedMonth') || new Date())).monthStart;
  const [currentDate, setCurrentDate] = useState(initDate);
  const navigate = useNavigate();
  const { user } = useAuthContext();

  useEffect(() => {
    const source = axios.CancelToken.source();
    (async () => {
      if (!user) return null;
      setLoading(true);
      try {
        const { monthStart, monthEnd } = parseDate(initDate);
        const response = await axios.get(`/carriage`, {
          params: {
            startDate: monthStart,
            endDate: monthEnd,
            populate: ['car', 'driver', 'paletts', 'client'],
            clientId: location.state?.client?._id,
          },
          cancelToken: source.token,
        });
        setApiData(response.data);
        if (response.data.length) {
          location.state.client = response.data[0].client;
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('axios request canceled');
          return;
        }
      }
      setLoading(false);

      window.print();
      navigate('/CarriagePaletteList', { state: { client: location.state.client } });
    })();

    return () => {
      source.cancel();
    };
  }, [user]);


  if (isLoading || !apiData.length) {
    return (
      <>

        {
          !apiData.length
          ? <div className={style.missingData}>Brak danych do wyświetlenia...</div>
          : null
        }
      </>
    );
  }
  const Small = ({text}) => {
    return <span style={{fontSize: '.7em'}}>{text}</span>
  }
  const cars = [...new Set(apiData.map((data) => data.car?.plate))].sort((...args) => {
    const [a, b] = args.map((plate) => plate.toUpperCase());
    return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
  });

  return (
    <div className={style.container}>
      <p>
        {['monthStart', 'monthEnd'].map((day) => new Date(parseDate(currentDate)[day]).toLocaleDateString('pl')).join(' - ')}
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', fontSize: '1.1em' }}>
        <div>Saldo palet EURO: {apiData[0]?.client?.paletteBallanceE}</div>
        <div className={style.contrahent}>Kontrahent: {location.state?.client?.companyName}</div>
        <div>Saldo palet DD: {apiData[0]?.client?.paletteBallanceDD}</div>
      </div>
      <div className={style.mainHeader}>
        <span>Pojazd</span>
        <span>Data</span>
        <span>Faktura</span>
        <span>Kierowca</span>
        <span>Trasa Z/Do</span>
        <span>Wymienione</span>
        <span>Załadowane</span>
        <span>Odebrane</span>
        <span>Zdane</span>
        <span>Saldo/trasa</span>
        <span>Kwit</span>
      </div>
      {cars.map((plate) => (
        <div className={style.carWeek} key={plate}>
          <div className={style.plate}>{plate}</div>
          <div className={style.data}>
            {apiData
              .filter((carriage) => carriage.car.plate === plate)
              .sort((...args) => {
                const [a, b] = args.map(({ day }) => Date.parse(day));
                return a - b;
              })
              .map((carriage) => {
                return (
                  <div className={style.carriageData} key={carriage._id}>
                    <div className={style.day}>
                    {new Date(carriage.day).toLocaleString('pl', { weekday: 'long' })}<br />{new Date(carriage.day).toLocaleDateString('pl')}
                    </div>
                    <div className={style.route}>
                        <div className={style.invoice}>{carriage.invoice || '-'}</div>
                    </div>
                    <div className={style.route}>
                        <div className={style.driver}>{carriage.driver?.name.split(' ').reduce((acc, element) => [acc, <br />, element]) || '-'}</div>
                    </div>
                    <div className={style.route}>
                      <ul className={style.routeList2}>
                        <li className={style.routeStart}>{carriage.routeStart || '-'}</li>
                        <li className={style.to}>{carriage.routeEnd || '-'}</li>
                      </ul>
                    </div>
                    <div className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteExchanged ? <li className={style.invoice}>{carriage.paletts?.paletteExchanged}<Small text='E'/></li> : '-'}
                        {carriage.paletts?.paletteExchangedDD ? <li className={style.invoice}>{carriage.paletts?.paletteExchangedDD} <Small text='DD'/></li> : '-'}
                      </ul>
                    </div>
                    <div className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteLoad ? <li className={style.invoice}>{carriage.paletts?.paletteLoad}<Small text='E'/></li> : '-'}
                        {carriage.paletts?.paletteLoadDD ? <li className={style.invoice}>{carriage.paletts?.paletteLoadDD}<Small text='DD'/></li> : '-'}
                      </ul>
                    </div>
                    <div className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteTaken ? <li className={style.invoice}>{carriage.paletts?.paletteTaken}<Small text='E'/></li> : '-'}
                        {carriage.paletts?.paletteTakenDD ? <li className={style.invoice}>{carriage.paletts?.paletteTakenDD}<Small text='DD'/></li> : '-'}
                      </ul>
                    </div>
                    <div className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteLeft ? <li className={style.invoice}>{carriage.paletts?.paletteLeft}<Small text='E'/></li> : '-'}
                        {carriage.paletts?.paletteLeftDD ? <li className={style.invoice}>{carriage.paletts?.paletteLeftDD}<Small text='DD'/></li> : '-'}
                      </ul>
                    </div>
                    <div className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteBalE ? <li className={style.invoice}>{carriage.paletts?.paletteBalE}<Small text='E' /></li> : '-'}
                        {carriage.paletts?.paletteBalDD ? <li className={style.invoice}>{carriage.paletts?.paletteBalDD}<Small text='DD' /></li> : '-'}
                      </ul>
                    </div>
                    <div className={style.route}>
                      {<input id='receipe' type='checkbox' name='receipe' checked={carriage.paletts?.receipe } onChange={() => {}} />}
                    </div>
                  </div>
                );
              })
              .reduce((acc, element) => [acc, <hr />, element])
            }
          </div>
        </div>
      ))}
    </div>
  );
}

